//  Buttons can be one of five different types/styles:
export const BUTTON_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  OUTLINE: 'outline',
  OUTLINE_LIGHT: 'outline-light', // Same as outline, but with white text + icon.
  ERROR: 'error',
  DARK: 'dark',
  ANCHOR: 'anchor',
  SLATE: 'slate',
  TEXT: 'text',
} as const;

type TypeConst = keyof typeof BUTTON_TYPE;
export type ButtonType = typeof BUTTON_TYPE[TypeConst];

//  Buttons can be one of five sizes
export const BUTTON_SIZE = {
  ICON: 'icon',
  MICRO: 'micro',
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
  XLARGE: 'x-large',
} as const;

type SizeConst = keyof typeof BUTTON_SIZE;
export type ButtonSize = typeof BUTTON_SIZE[SizeConst];
